module.exports = __webpack_public_path__ + "img/psd.a38b4e03.png";